import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-store-profile-location",
  templateUrl: "./store-profile-location.component.html",
  styleUrls: ["./store-profile-location.component.scss"]
})
export class StoreProfileLocationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
